import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchNotificationPreferences = async (patientId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${__API_URL__}/api/patient/patient/${patientId}/notification-preferences/`,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useGetNotificationPreferences = (patientId) => {
  return useQuery({
    queryKey: ["notification_preferences", patientId],
    queryFn: () => fetchNotificationPreferences(patientId),
    enabled: Boolean(patientId),
  });
};

export default useGetNotificationPreferences;
